/*
 * @Author: HTT httishere0728@gmail.com
 * @Date: 2024-09-03 21:58:04
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-09-14 14:38:38
 * @FilePath: /widverse-v2/src/constants/creator.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
type RECEIPT_TYPE = {
  value: string
  label: string
}

export const TypesKey: any = {
  Starbucks: 'starbucks',
  Luckin: 'luckin',
  Xicha: 'xicha',
  ChaBaiDao: 'chabaidao',
  GoodMe: 'goodme',
}

export const ReceiptTypes: RECEIPT_TYPE[] = [
  {
    value: TypesKey.Starbucks,
    label: '星巴克',
  },
  {
    value: TypesKey.Luckin,
    label: '瑞幸咖啡',
  },
  {
    value: TypesKey.Xicha,
    label: '喜茶',
  },
  {
    value: TypesKey.ChaBaiDao,
    label: '茶百道',
  },
  {
    value: TypesKey.GoodMe,
    label: '古茗',
  },
]
